<style scoped>
.overlay {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 100;
}
.media-content {
  position: relative;
}
.prompt-message-wrapper {
  padding: 16px;
}
.media-title {
  padding: 8px;
}
</style>

<template>
  <div class="media-content" v-if="fetchedVolatility">
    <transition name="slide-fade" mode="out-in">
      <video-item
        :channel="channel"
        :media="media"
        :currentTime="currentTime"
        v-if="(media.type==='video' || media.type==='youtube' || media.type==='mp4link')"
        :watched="volatilityRecordExist"
        @onUpdateTime="onUpdateTime"
        :flagPauseSwitch="flagPauseSwitch"
        :timestamp="timestamp"
        :timestampTrigger="timestampTrigger"
        :overlays="overlays"
        @onPlayerState="onPlayerState"
        :playerState="playerState"
        :startFrom="startFrom"
        />
      <img-item :media="media" v-else-if="media.type==='img'" />
      <PDFItem :media="media" v-else-if="media.type==='pdf'" />
      <ModelItem :media="media" v-else-if="isModelType(media.type)" />
      <WysiwygItem :media="media" v-else-if="media.type==='wysiwyg'" :isAdmin="isAdmin"/>
    </transition>
    <div class="media-title"><b>{{media.name}}</b></div>
    <div class="prompt-message-wrapper" v-if="media.type === 'video' && media.hasOwnProperty('volatility') && media.volatility">
      <b>{{ volatilityRecordExist ? $t('media.watchedBefore') : $t('media.watchOnce')}}</b>
    </div>
  </div>
</template>

<script>

// Components
import VideoItem from '@/components/Media/Content/VideoItem.vue'
import ImgItem from '@/components/Media/Content/ImgItem.vue'
import PDFItem from '@/components/Media/Content/PDFItem.vue'
import ModelItem from '@/components/Media/Content/ModelItem.vue'
import WysiwygItem from '@/components/Media/Content/WysiwygItem.vue'

// Library
import axios from "axios";

export default {
  name: 'MediaContentPanel',
  components: {
    VideoItem,
    ImgItem,
    PDFItem,
    ModelItem,
    WysiwygItem,
  },
  props: {
    channel: {
      type: Object,
      required: true
    },
    media: {
      type: Object,
      required: true
    },
    overlays: {
      type: Array,
      required: true
    },
    flagPauseSwitch: {
      type: Boolean,
      required: false
    },
    timestamp: {
      type: Number,
      required: false
    },
    flagEditMode: {
      type: Boolean
    },
    isAdmin: {
      type: Boolean
    },
    timestampTrigger: {
      type: Boolean,
      default: false
    },
    currentTime: {
      type: Number,
      required: true
    },
    playerState: {
      type: Object,
      default() {
        return {}
      }
    },
    startFrom: {
      type: String
    }
  },
  data() {
    return {
      volatilityRecordExist: false,
      fetchedVolatility: false,
    }
  },
  mounted() {
    if(!(this.isAdmin || this.$store.getters.isAdmin)) {
      this.fetchStatMedia();
      this.fetchVolatility();
    } else {
      this.fetchedVolatility = true;
    }
  },
  methods: {
    // Fetch
    fetchStatMedia() {
      axios.post(this.$store.getters.urlApi + "view/media/" + this.media._id, {}, {
        headers: {
          token: this.$store.state.auth.token
        },
      });
    },
    fetchVolatility() {
      if(this.media.type === 'video' && this.media.hasOwnProperty('volatility') && this.media.volatility) {
        axios.get(this.$store.getters.urlApi + "media/" + this.media._id + '/volatility', {
          headers: {
            token: this.$store.state.auth.token
          },
        }).then(res => {
          this.volatilityRecordExist = res.data.data.result;
          this.fetchedVolatility = true;
        });
      } else {
        this.fetchedVolatility = true;
      }
    },

    // Event
    onUpdateTime(payload) {
      this.$emit('onUpdateTime', payload);
    },
    onPlayerState(payload) {
      this.$emit('onPlayerState', payload);
      if(this.media.type === 'video' && this.media.hasOwnProperty('volatility') && this.media.volatility) {
        if(payload.state === 'ended') {
          this.volatilityRecordExist = true;
        }
      }
    },

    // Flag
    isModelType(type) {
      var array = ["stl", "obj", "three", "collada", "ply", "gltf"];
      return array.includes(type);
    },
  },
}
</script>
